/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2021-08-18 17:48:56
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @LastEditTime: 2025-12-08 17:39:41
 */
// 财务管理
const map = {
  reviewWithdrawal: () => import('@/views/finance/ReviewWithdrawal'),
  monthlyAccounting: () => import('@/views/finance/MonthlyAccounting'),
  monthlyAccountingList: () => import('@/views/finance/MonthlyAccountingList'),
  createRedManPaymentOrder: () => import('@/views/finance/components/CreatePayment'), // 新建付款申请单
  createAdvertisingPaymentOrder: () => import('@/views/finance/components/CreatePayment'), // 新建广告付款申请单
  dealRealPay: () => import('@/views/finance/DealRealPay'),
  taxRateList: () => import('@/views/finance/TaxRateList'),
  // paymentSource: () => import('@/views/finance/PaymentSource'),
  paymentSource: () => import('@/views/finance/OfflineCollList'), // 线下收款列表
  currencyConversion: () => import('@/views/finance/CurrencyConversion'),
  applyInvoiceFinance: () => import('@/views/finance/OfflineShipmentInvoice'), // 京东AA开票
  summaryHongKong: () => import('@/views/finance/SummaryHongKong'), // 芳星办公室月盈利
  purchasePayment: () => import('@/views/finance/PurchasePayment'),
  invoiceDispose: () => import('@/views/finance/invoiceDispose'),
  monthlyRecognizedIncome: () =>
    import('@/views/finance/MonthlyRecognizedIncome'),
  // stationPromotionFeeImport: () => import('@/views/finance/StationPromotionFeeImport'), //站内推广费导入
  supplierMonthState: () => import('@/views/finance/SupplierMonthState'), // 供应商月对账单
  salesDaily: () => import('@/views/finance/SalesDaily'), // 销售日报
  refundAndToWarehouse: () => import('@/views/finance/RefundAndToWarehouse'), // 退款不退货以及退货入库
  dailyBatchTreatment: () => import('@/views/finance/DailyBatchTreatment'), // 库龄查询
  distributionAging: () => import('@/views/finance/DistributionAging'), // 分销账龄表
  bhTaxStatistics: () => import('@/views/finance/BhTaxStatistics'), // 保宏税费统计
  grossProfit: () => import('@/views/finance/GrossProfit'), // 发货毛利
  paymentList: () => import('@/views/finance/PaymentList'), // 付款单一览
  paymentDetail: () => import('@/views/finance/PaymentDetail'), // 付款单详情一览
  createPaymentOrder: () =>
    import('@/views/finance/components/PaymentOrderDetail'), // 新建付款单
  editPaymentOrder: () =>
    import('@/views/finance/components/PaymentOrderDetail'), // 查看付款单
  tongLianApplyList: () => import('@/views/finance/TongLianApplyList'), // 发货毛利
  inboundAndOutboundList: () =>
    import('@/views/finance/InboundAndOutboundList'), //  其他出入库处理(
  balanceOfMerchants: () => import('@/views/finance/BalanceOfMerchants'), //   客商余额结转
  capitalFlowDone: () => import('@/views/finance/CapitalFlowDone'), //  资金流水代办
  collectionAccountList: () => import('@/views/finance/CollectionAccountList'), // 收款账号列表
  icomeExpendList: () => import('@/views/finance/BalanceDetails'), // 余额收支列表
  redManAccountingList: () => import('@/views/finance/RedManAccountingList'), // 红人结算账单配置列表
  transferSampleOrderList: () =>
    import('@/views/finance/TransferSampleOrderList'), // 转样品下单列表
  merchantBankAccount: () => import('@/views/finance/MerchantBankAccount'), // 客商银行账户
  merchantBankAccountDetail: () => import('@/views/finance/MerchantBankAccount/Detail'), // 客商银行账户详情
  researchProject: () => import('@/views/finance/ResearchProject'), // 研发项目
  researchProjectDetail: () => import('@/views/finance/ResearchProject/Detail'), // 研发项目详情
  amortizationProject: () => import('@/views/finance/AmortizationProject'), // 摊销项目
  amortizationProjectDetail: () => import('@/views/finance/AmortizationProject/Detail'), // 摊销项目详情
  AmortizationFeeProjectList: () => import('@/views/finance/AmortizationFeeProject/index'), // 摊销项目维护列表
  AmortizationFeeProjectDetail: () => import('@/views/finance/AmortizationFeeProject/Detail'), // 摊销项目维护详情
  AmortizationFeeTypeList: () => import('@/views/finance/AmortizationFeeType/index'), // 可摊销费用类型配置
  AmortizationDetailPosting: () => import('@/views/finance/AmortizationDetailPosting/index.vue'), // 摊销明细入账列表
  VoucherAccountDefinitionList: () => import('@/views/finance/VoucherAccountDefinition/index.vue'), // 凭证科目定义
  VoucherAccountDefinitionDetail: () => import('@/views/finance/VoucherAccountDefinition/Detail'), // 凭证科目定义详情
  Generalledger: () => import('@/views/finance/Generalledger/index'), // 通用台账
  statementOfAccount: () => import('@/views/finance/StatementOfAccount'), // 应收实收对账单
  financialStatement: () => import('@/views/finance/FinancialStatement/index'), // 报表
  notRecognitionRevenue: () => import('@/views/finance/NotRecognitionRevenue'), // 客商银行账户
  reconciliationDetails: () => import('@/views/finance/ReconciliationDetails'), // 商品对账明细
  temConfList: () => import('@/views/finance/TemConfList'), // 模板配置列表
  financialStatementList: () =>
    import('@/views/finance/FinancialStatementList'), // 财务报表列表
  financReportFormsTemplateDetail: () =>
    import('@/views/finance/FinancReportForms/FinancReportFormsTemplateDetail'), // 新增财务报表模板
  financReportFormsDetail: () =>
    import('@/views/finance/FinancReportForms/FinancReportFormsDetail'), // 财务报表
  zfbBillFlow: () => import('@/views/finance/ZfbBillFlow'), // 支付宝账单流水
  zfbBillTemConf: () => import('@/views/finance/ZfbBillTemConf'), // 账单支付宝模板配置
  redManSettlementStatisticsReport: () =>
    import('@/views/finance/RedManSettlementStatisticsReport'), // 红人结算统计报表
  introductionOfPromotionFee: () =>
    import('@/views/finance/IntroductionOfPromotionFee'), // 推广费导入
  // offSitePromotionCost: () => import("@/views/finance/OffSitePromotionCost"), // 站外推广费导入

  // 财务结算
  activityOrder: () => import('@/views/financeClearing/ActivityOrder'), // 活动订单
  generateBillSteps: () => import('@/views/finance/generateBillSteps'), // 生成账单步骤
  // 钉钉/飞书费用
  costAllocation: () => import('@/views/finance/CostAllocation'), // 费用分配
  compensationMechanismOrder: () => import('@/views/finance/CompensationMechanismOrder'), // 补偿机制订单
  nCReconciliationDetail: () => import('@/views/finance/NCReconciliationDetail'), // nc对账明细
  pettyCashOrderTableList: () => import('@/views/finance/PettyCashOrderTableList'), // 备用金使用报表
  invoiceCheckTableList: () => import('@/views/finance/InvoiceCheck/InvoiceCheckTableList'), // 发票核对
  ncInvoiceCheckProgressTableList: () => import('@/views/finance/InvoiceCheck/NcInvoiceCheckProgressTableList'), // 发票进度明细
  invoiceCheckDetail: () => import('@/views/finance/InvoiceCheck/InvoiceCheckDetail'), // 核对明细
  invoiceMergeTableList: () => import('@/views/finance/InvoiceMerge/InvoiceMergeTableList'), // 发票合并
  ncFreightChargeOrderTableList: () => import('@/views/finance/NcFreightChargeOrderTableList'), // 运费挂账
  returnDisposal: () => import('@/views/finance/ReturnDisposal'), // 退货处置
  ncAlipayExpandSummaryModuleTableList: () => import('@/views/finance/NCExpansiveGold/NcAlipayExpandSummaryModuleTableList'), // NC膨胀金
  generateReportManagerTableList: () => import('@/views/finance/GenerateReportManager/GenerateReportManagerTableList'), // 生成报表
  expansionFundsDetailsList: () => import('@/views/finance/NCExpansiveGold/ExpansionFundsDetailsList'), // 膨胀金推送单明细
  sampleOrderVoucherModuleList: () => import('@/views/finance/SampleOrderVoucherModuleList'), // 样品下单税费凭证列表
  sampleOrderVoucherDetailModule: () => import('@/views/finance/SampleOrderVoucherDetailModule'), // 样品下单税费明细列表
  channelLaunchROI: () => import('@/views/finance/ChannelReleaseReportData/ChannelLaunchROI'), // 渠道投放ROI报表
  ncDeptShareConfigTableList: () => import('@/views/finance/NcDeptShareConfig/NcDeptShareConfigTableList'), // 业财一体化配置
  ncShopScopeConfigTableList: () => import('@/views/finance/NcShopScopeConfig/NcShopScopeConfigTableList'), // 业财一体化配置--店铺
  pettyCashRemittanceList: () => import('@/views/finance/PettyCashRemittanceList'), // 备用金打款列表
  pettyCashRemittanceDetailList: () => import('@/views/finance/PettyCashRemittanceDetailList'), // 备用金打款明细列表
  pettyCashRemittanceDetail: () => import('@/views/finance/components/PettyCashRemittanceDetail'), // 备用金打款详情
  pettyCashRemittanceExportDetail: () => import('@/views/finance/components/PettyCashRemittanceExportDetail'), // 备用金打款批量导出确认详情
  pettyCashRemittanceExport: () => import('@/views/finance/PettyCashRemittanceExport'), // 备用金打款批量导出确认列表
  ncExchangeList: () => import('@/views/finance/NcExchangeList'), // nc同步汇率
  balanceStateMentList: () => import('@/views/finance/BalanceStateMentList'), // 委外结算对账单列表
  balanceStateMentDetail: () => import('@/views/finance/BalanceStateMentDetail'), // 委外结算对账单详情
  inventoryBoard: () => import('@/views/finance/InventoryBoard'), // 库存看板
  creditApplyList: () => import('@/views/finance/CreditManagement/CreditApply/creditApplyList'), // 授信申请列表
  creditApplyDetail: () => import('@/views/finance/CreditManagement/CreditApply/creditApplyDetail'), // 授信申请详情
  creditCustomerList: () => import('@/views/finance/CreditManagement/CreditCustomerList/creditCustomerList'), // 授信客户列表
  creditManageList: () => import('@/views/finance/CreditManagement/CreditMgmDetailsList/CreditManagementList'), // 授信管理明细
  creditOverdueDetailsList: () => import('@/views/finance/CreditManagement/CreditOverdueDetailsList'), // 逾期记录明细
  groupInventorySignboard: () => import('@/views/finance/GroupInventorySignboard/index'), // 集团库存看板
  freeGoodsConfig: () => import('@/views/finance/FreeGoodsConfig'), // 主赠品配置清单
  goodsSuites: () => import('@/views/finance/GoodsSuites'), // 主赠品管理列表
  paymentElectronicReceipt: () => import('@/views/finance/PaymentElectronicReceipt'), // 公司付款电子回单
  stockBoardBrandSkuDetailList: () => import('@/views/finance/StockBoardBrandSkuDetailList'), // 风险库存转入转出明细
  stockBoardBrandSkuChangeList: () => import('@/views/finance/StockBoardBrandSkuChangeList'), // 出入库汇总数据
  stockBoardBrandSkuChangeDetailList: () => import('@/views/finance/StockBoardBrandSkuChangeDetailList'), // 出入库明细数据
  stockBoardBrandSku: () => import('@/views/finance/StockBoardBrandSku'), // SKU汇总数据
  skuStandardQuotationList: () => import('@/views/finance/SkuStandardQuotationList'), // 物料标准成本
  // 认领
  TmsClaimRuleList: () => import('@/views/finance/TmsClaimRule/index'),
  TmsClaimRuleDetail: () => import('@/views/finance/TmsClaimRule/Detail'),
  // 流水
  ReceivableRecordsList: () => import('@/views/finance/ReceivableRecords/index'),
  // 付款流水
  PayFlowManagement: () => import('@/views/finance/PayFlowManagement/index'),
  // 内部交易结算
  InnerTradePurchaseSettlementList: () => import('@/views/finance/InternalTransaction/InternalTransactionSettlement/index'),
  InnerTradePaymentApplyList: () => import('@/views/finance/InternalTransaction/InnerTradePaymentApply/index'),
  InnerTradePaymentSnapshotList: () => import('@/views/finance/InternalTransaction/InnerTradePaymentSnapshot/index'),
  InnerTradePaymentSnapshotSummary: () => import('@/views/finance/InternalTransaction/InnerTradePaymentSnapshot/summary'),
  InnerTradePaymentRealtimeSummary: () => import('@/views/finance/InternalTransaction/InnerTradePaymentRealtimeSummary/index'),
  // InnerTradePaymentApplyDetail: () => import('@/views/finance/InternalTransaction/InnerTradePaymentApply/Detail'),
  tobSalesSettlementList: () => import('@/views/finance/TobSalesSettlement/index'), // tob销售结算单列表
  tobSalesSettlementDetail: () => import('@/views/finance/TobSalesSettlement/Detail'), // tob销售结算单详情
  tobSalesSettlementEdit: () => import('@/views/finance/TobSalesSettlement/Detail'), // tob销售结算单编辑
  tobSalesOrderList: () => import('@/views/finance/TobSalesOrder/index'), // tob销售订单列表
  tobSalesOrderDetail: () => import('@/views/finance/TobSalesOrder/Detail'), // tob销售订单详情
  tobSalesOrderEdit: () => import('@/views/finance/TobSalesOrder/Detail'), // tob销售订单编辑
  InternalServiceFeeRule: () => import('@/views/finance/InternalServiceFeeRule/index'),
  InternalServiceFeeRuleDetail: () => import('@/views/finance/InternalServiceFeeRule/Detail'),
  InternalServiceFee: () => import('@/views/finance/InternalServiceFee/index'), // 内部服务费
  InnerTradeAdvancePaymentConfigList: () => import('@/views/finance/InnerTradeAdvancePaymentConfig/index'), // 内部交易预付申请单列表
  InnerTradePaymentApply: () => import('@/views/finance/InternalTransaction/InnerTradePaymentApply/Detail'), // 内部交易付款申请单详情
  PrepaymentApplicationDetail: () => import('@/views/finance/InternalTransaction/InnerTradePaymentApply/PrepaymentApplicationDetail'), // 预付申请
  PrepaymentRefundDetail: () => import('@/views/finance/InternalTransaction/InnerTradePaymentApply/PrepaymentRefundDetail'), // 预付退款
  JdpopInsuranceBill: () => import('@/views/finance/JdpopInsuranceBill/index'), // 京东POP保险收支项
  NCBillTax: () => import('@/views/finance/NCBillTax/index'), // 跨境税费
  laborCostMultiTab: () =>
    new Promise((resolve) => {
      require.ensure([], (require) => resolve(require('@/views/finance/LaborCostMultiTab/index')))
    }),
  inputInvoicePoolTbList: () => import('@/views/finance/InputInvoicePoolTbList/index'),
  // 资金日报
  dailyReport: () => import('@/views/finance/DailyReport/index'),
  LeaseRateConfig: () => import('@/views/finance/RightOfUseAssetManage/LeaseRateConfig/index'), // 租赁利率配置
  AssetMaintenanceEdit: () => import('@/views/finance/RightOfUseAssetManage/AssetMaintenance/Detail'), // 资产维护新增
  AssetMaintenanceDetail: () => import('@/views/finance/RightOfUseAssetManage/AssetMaintenance/Detail'), // 资产维护详情
  AssetMaintenance: () => import('@/views/finance/RightOfUseAssetManage/AssetMaintenance'), // 资产维护列表
  AssetVersionList: () => import('@/views/finance/RightOfUseAssetManage/AssetVersionList'), // 资产历史版本列表
  RightOfUseAssetPushList: () => import('@/views/finance/RightOfUseAssetPush/index'), // 使用权资产
  SrmInvoiceMonitor: () => import('@/views/finance/SrmInvoiceMonitor/index'), // 发票监控
  MaterialSettings: () => import('@/views/finance/SrmInvoiceMonitor/MaterialSettings'), // 物料设置
  // NC账务检查自动对账
  bankStatement: () => import('@/views/finance/NCManagement/BankStatement/index.vue'),
  balanceAdjustment: () => import('@/views/finance/NCManagement/BalanceAdjustment/index.vue'),
  InnerTradeBalanceRecon: () =>
    import('@/views/finance/NCManagement/InnerTradeBalanceRecon/index.vue'),
  InnerTradeCashFlowRecon: () =>
    import('@/views/finance/NCManagement/InnerTradeCashFlowRecon/index.vue'),
  PlatformAccountRecon: () =>
    import('@/views/finance/NCManagement/PlatformAccountRecon/index.vue'),
  InnerTradeReconRule: () =>
    import('@/views/finance/NCManagement/InnerTradeReconRule/Detail.vue')
}

export default map
